module.exports = __webpack_public_path__ + "static/media/Apple Macbook Pro 15\" Silver.6358e339.png";